import React from "react";
import * as SC from "./styled";
import servicesData from "@assets/json/services.json";
import officesData from "@assets/json/offices.json";
import socialsData from "@assets/json/socials.json";
import HubspotForm from "@components/hubspotForm";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <SC.Footer>
      <SC.Subscribe>
        <SC.Summary>
          <SC.TextWrapper>
            <SC.Title>Get Expert Insights.</SC.Title>
            <SC.Subtitle>
              We'll put industry trends in your Inbox only when we feel it's
              really helpful.
            </SC.Subtitle>
          </SC.TextWrapper>
        </SC.Summary>

        <SC.Form>
          <HubspotForm
            id="hubspot-form"
            formId="d9f3f5b3-55b7-41aa-a124-94864e1b86f7"
            portalId="6240823"
          />
        </SC.Form>
      </SC.Subscribe>

      <SC.Container>
        <SC.Info>
          <SC.InfoColumn>
            <SC.InfoTitle>Headquarters</SC.InfoTitle>
            <SC.SimpleColumn>
              <SC.InfoTitle>Dallas Fort Worth</SC.InfoTitle>
              <SC.InfoText>151 W. Walters Street</SC.InfoText>
              <SC.InfoText>Lewisville, TX 75057 USA</SC.InfoText>
              <SC.InfoText>214.774.2390</SC.InfoText>
            </SC.SimpleColumn>

            <SC.InfoTitle>Social Media</SC.InfoTitle>
            <SC.Socials>
              {socialsData.socials.map((social, i) => (
                <SC.SocialsLink
                  key={i}
                  href={social.url}
                  type={social.name}
                  target="_blank"
                  aria-label={`Visit our ${social.name}`}
                />
              ))}
            </SC.Socials>
          </SC.InfoColumn>

          <SC.InfoColumn>
            <SC.InfoTitle>SERVICES</SC.InfoTitle>
            <SC.SimpleColumn>
              {servicesData.services.map((service, i) => (
                <SC.InfoLink to={service.url} key={i}>
                  {service.shortTitle}
                </SC.InfoLink>
              ))}
            </SC.SimpleColumn>
          </SC.InfoColumn>

          <SC.InfoColumn>
            <SC.ExternalLink
              href="https://tonic3.com/documents/Tonic3_Quality_Policy_en_es_br.pdf"
              target="_blank"
            >
              Quality Policy
            </SC.ExternalLink>
            <SC.InfoLink to="/cookie-information">Cookie policy</SC.InfoLink>
          </SC.InfoColumn>
        </SC.Info>

        <SC.OfficesContainer>
          <SC.Offices>
            {Object.values(officesData).map((office, i) => (
              <SC.Office key={i}>{office.title}</SC.Office>
            ))}
          </SC.Offices>

          <SC.Responsive>
            <SC.IsoIconsContainer>
              <SC.GreatPlaceToWorkIcon alt="Great Place" />
              <SC.IsoCertifiedIcon alt="ISO" />
            </SC.IsoIconsContainer>

            <SC.Copyright>
              {currentYear} Copyright. All Rights Reserved
            </SC.Copyright>
          </SC.Responsive>
        </SC.OfficesContainer>
      </SC.Container>
    </SC.Footer>
  );
};

export default Footer;
